import { form } from '../formState'

import { useTexts } from '../hooks/useTexts'
import { createValidateName } from '../hooks/validations/createValidateName'

export function Name() {
  const texts = useTexts()

  form.useAddFieldValidation<'name'>('name', async (field, _formApi) => {
    const nameValidation = await createValidateName(texts, field.value)

    return nameValidation.nameRequiredError?.message || nameValidation.nameMaxLengthError?.message
  })

  return (
    <form.TextField label={texts.labelName} validateOn="change" name="name" testId="region-name" />
  )
}
